import { Component, OnInit, Input } from '@angular/core';
import { QuestionnaireMetrics } from 'src/app/services/questionnaire/questionnaire.service';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'xqnr-q-stats',
    templateUrl: './q-stats.component.pug',
    styleUrls: ['./q-stats.component.scss'],
    standalone: false
})
export class QStatsComponent implements OnInit {
  @Input() questions: number;
  @Input() metrics: QuestionnaireMetrics;

  fa = {
    info: faInfoCircle
  };

  constructor() {}

  ngOnInit(): void {}
}
